// Settings.jsx
import React, { useEffect, useState } from 'react';
import { 
  FiUser, 
  FiBell, 
  FiShield, 
  FiEye,
  FiChevronRight,
  FiMail,
  FiPhone,
  FiGlobe,
  FiClock,
  FiMonitor,
  FiSmartphone,
  FiSave,
  FiLock
} from 'react-icons/fi';
import '../../../assets/css/sellers/dashboard/sellersetting/sellersettings.css';
import { MdLocationOn } from 'react-icons/md';
import SellerMasterLayout from 'layouts/SellerMasterLayout';
import { useContext } from 'react';
import AppContext from 'context/AppContext';
import axios from 'axios';

const SellerSettings = () => {
  // Account Settings State
  const{loggedInSeller,baseUrl,authToken}=useContext(AppContext);
  const [accountSettings, setAccountSettings] = useState({});
  //   name: 'Sara Khan',
  //   email: 'estateexpert@gmail.com',
  //   phone: '+92 300 1234567',
  //   Address: 'Pakistan',
  //   HQ: 'Pakistan-map'
  const[name,setName]=useState();
  const[email,setEmail]=useState();
  const[phoneNumber,setPhoneNumber]=useState();
  const[location,setLocation]=useState();
  const[HQ,setHQ]=useState();
// console.log(authToken);  
const viewSettings = () => {
    // const formData = new FormData();
    // formData.append("id", loggedInSeller.id);
    // formData.append("name", loggedInSeller.name);
    // formData.append("email",  loggedInSeller.email);
    // formData.append("phoneNumber",loggedInSeller.phoneNumber);
    // formData.append("location",  loggedInSeller.location);
    // formData.append("HQ",  loggedInSeller.HQ);
    axios.get(`${baseUrl}/seller/setting/viewSetting`, {
        headers: {
            Authorization: `Bearer ${authToken}`
        }
    })
    .then((response) => {
       console.log(accountSettings);
       console.log(response.data);
        console.log(response.data.seller);
        if(response.data.success){
            setAccountSettings(response.data.seller);
        }
    })
    .catch((error)=>{
        console.log(error);
    });
}
//  axios.get(`${baseUrl}/seller/setting/viewSetting`, {
//     headers: {
//         Authorization: `Bearer ${authToken}`
//     }
// })
// .then((response) => {
//     console.log("Response:", response.data);
//     console.log("Seller:", response.data.seller);

//     setAccountSettings(response.data.seller);
// })
// .catch((error)=>{
//     console.log(error);
// });
// }

useEffect(() => {
    const seller = JSON.parse(localStorage.getItem("loggedInSeller"))
    if (seller) {
        setAccountSettings(seller);
    }
}, []);
useEffect(() => {
    viewSettings();
}, []);
  // Notification Settings State
  const [notificationSettings, setNotificationSettings] = useState({
    desktopNotifications: true,
    emailNotifications: true,
    activityEmail: 'estateexpert@gmail.com',
    sendActivitySummary: 'Daily',
    bookingReminders: '1st mins, 30 min: 1 hours',
    automaticReportSettings: 'Monthly'
  });

  // Security Settings State
  const [securitySettings, setSecuritySettings] = useState({
    twoFactorAuth: false,
    devices: [
      { id: 1, name: 'MacBook Pro', location: 'Karachi, Pakistan', lastActive: '2 mins ago', current: true },
      { id: 2, name: 'iPhone 14', location: 'Lahore, Pakistan', lastActive: '1 hour ago', current: false }
    ]
  });

  // Appearance Settings State
  const [appearanceSettings, setAppearanceSettings] = useState({
    mode: 'Light',
    reduceMotion: false,
    startOfWeek: 'Sunday',
    hoursToShow: 12
  });

  // Toggle handlers
  const handleToggle = (section, key) => {
    if (section === 'notification') {
      setNotificationSettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    } else if (section === 'security') {
      setSecuritySettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    } else if (section === 'appearance') {
      setAppearanceSettings(prev => ({
        ...prev,
        [key]: !prev[key]
      }));
    }
  };

  // Dropdown handlers
  const handleDropdownChange = (section, key, value) => {
    if (section === 'account') {
      setAccountSettings(prev => ({ ...prev, [key]: value }));
    } else if (section === 'notification') {
      setNotificationSettings(prev => ({ ...prev, [key]: value }));
    } else if (section === 'appearance') {
      setAppearanceSettings(prev => ({ ...prev, [key]: value }));
    }
  };

  // Save Changes Handler
  const handleSaveChanges = () => {
    alert('Settings saved successfully! ✅');
    console.log('Saved Settings:', {
      accountSettings,
      notificationSettings,
      securitySettings,
      appearanceSettings
    });
  };

  // Change Password Handler
  const handleChangePassword = () => {
    alert('Password change modal will open here');
  };

  // Device removal handler
  const handleRemoveDevice = (deviceId) => {
    const confirmed = window.confirm('Are you sure you want to remove this device?');
    if (confirmed) {
      setSecuritySettings(prev => ({
        ...prev,
        devices: prev.devices.filter(d => d.id !== deviceId)
      }));
    }
  };

  return (
    <SellerMasterLayout>
    <div className="settings-page">
      {/* Header */}
      <div className="settings-header">
        <h1 className="settings-title">Settings</h1>
        <p className="settings-subtitle">Manage your  account and system preferences.</p>
      </div>

      {/* Settings Grid */}
      <div className="settings-grid">
        
        {/* LEFT COLUMN */}
        <div className="settings-column">
          
          {/* Account Settings Card */}
          <div className="settings-card slide-up">
            <div className="card-header-section">
              <div className="header-icon-wrapper">
                <div className="header-icon account">
                  <FiUser />
                </div>
                <div className="header-text">
                  <h3 className="card-title">Business Settings</h3>
                  <p className="card-subtitle">{accountSettings?.name}</p>
                </div>
              </div>
              <FiChevronRight className="chevron-icon" />
            </div>

            <div className="settings-list">
              <div className="setting-item">
                <div className="setting-label">
                  <FiMail className="setting-icon" />
                  <span>Business Email</span>
                </div>
                <input 
                  type="email" 
                  value={accountSettings?.email|| ""}
                  onChange={(e) => handleDropdownChange('account', 'email', e.target.value)}
                  className="setting-input"
                />
              </div>

              <div className="setting-item">
                <div className="setting-label">
                  <FiPhone className="setting-icon" />
                  <span>Business Phone Number</span>
                </div>
                <input 
                  type="tel" 
                  value={accountSettings?.phonenumber||""}
                  onChange={(e) => handleDropdownChange('account', 'phonenumber', e.target.value)}
                  className="setting-input"
                />
              </div>
              
              <div className="setting-item">
                <div className="setting-label">
                  <MdLocationOn className="setting-icon" />
                  <span>Business Postal Address</span>
                </div>
                <input 
                  type="tel" 
                  value={accountSettings?.location||""}
                  onChange={(e) => handleDropdownChange('account', 'location', e.target.value)}
                  className="setting-input"
                />
              </div>
            </div> 
          </div>

          {/* Notification Settings Card */}
          {/* <div className="settings-card slide-up" style={{ animationDelay: '0.1s' }}>
            <div className="card-header-section">
              <div className="header-icon-wrapper">
                <div className="header-icon notification">
                  <FiBell />
                </div>
                <div className="header-text">
                  <h3 className="card-title">Notification Settings</h3>
                  <p className="card-subtitle">Settings | preferences</p>
                </div>
              </div>
              <FiChevronRight className="chevron-icon" />
            </div>

            <div className="settings-list">
              <div className="setting-item">
                <div className="setting-label">
                  <span>In app Notifications</span>
                </div>
                <label className="toggle-switch">
                  <input 
                    type="checkbox" 
                    checked={notificationSettings.desktopNotifications}
                    onChange={() => handleToggle('notification', 'desktopNotifications')}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>

              <div className="setting-item">
                <div className="setting-label">
                  <span>Email Notifications</span>
                </div>
                <label className="toggle-switch">
                  <input 
                    type="checkbox" 
                    checked={notificationSettings.emailNotifications}
                    onChange={() => handleToggle('notification', 'emailNotifications')}
                  />
                  <span className="toggle-slider"></span>
                </label>
              </div>
            </div>
          </div> */}

        </div>
      </div> 

      {/* Save Button */}
      <div className="save-button-container">
        <button onClick={handleSaveChanges} className="save-changes-btn">
          <FiSave />
          Save Changes
        </button>
      </div>
    </div>
    </SellerMasterLayout>
  );
};

export default SellerSettings;